import { useEffect } from "react";
import { useDispatch } from "react-redux";
import "./App.css";
import ShmupListPage from "./pages/ShmupListPage";
import shmupsListThunk from "./redux/thunks/shmupThunks";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(shmupsListThunk);
  }, [dispatch]);

  return (
    <>
      <ShmupListPage />
    </>
  );
}

export default App;
